import "core-js/stable";
import "regenerator-runtime/runtime";

// 强制设置微软雅黑字体，特别针对360浏览器兼容模式
function forceMicrosoftYaHeiFont() {
  // 检测360浏览器
  const is360 = navigator.userAgent.indexOf('360') > -1 || 
                navigator.userAgent.indexOf('360SE') > -1 || 
                navigator.userAgent.indexOf('360EE') > -1;
  
  // 检测IE浏览器
  const isIE = navigator.userAgent.indexOf('MSIE') > -1 || 
               navigator.userAgent.indexOf('Trident') > -1;
  
  // 强制设置字体
  const fontFamily = '"Microsoft YaHei", "微软雅黑", "MS YaHei", "SimHei", Arial, sans-serif';
  
  // 添加样式到head
  const style = document.createElement('style');
  style.type = 'text/css';
  style.innerHTML = `
    html, body, * {
      font-family: ${fontFamily} !important;
    }
    .el-input__inner, .el-textarea__inner, .el-select, .el-button,
    .el-menu, .el-table, .el-form-item__label, .el-dialog,
    .el-message, .el-notification {
      font-family: ${fontFamily} !important;
    }
  `;
  document.head.appendChild(style);
  
  // 如果是360或IE浏览器，添加特殊处理
  if (is360 || isIE) {
    document.documentElement.style.fontFamily = fontFamily;
    document.body.style.fontFamily = fontFamily;
    
    // 添加浏览器类名
    if (is360) {
      document.documentElement.className += ' ua-360';
    }
    if (isIE) {
      document.documentElement.className += ' ua-ie';
    }
  }
}

// const emitter = require('events').EventEmitter;

// // 添加监听器
// emitter.on('upgrade', () => {
//   console.log('Upgrade event triggered');
// });

// // 监听程序退出事件
// process.on('exit', () => {
//   emitter.removeAllListeners(); // 移除所有监听器
//   console.log('程序已退出，监听器已关闭');
// });

// // 捕获 Ctrl+C 或其他终止信号
// process.on('SIGINT', () => {
//   console.log('收到终止信号，程序退出');
//   process.exit();
// });

// 在DOM加载前就执行
forceMicrosoftYaHeiFont();

// DOM加载完成后再次确保字体设置
document.addEventListener('DOMContentLoaded', function() {
  forceMicrosoftYaHeiFont();
});


import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
import 'normalize.css/normalize.css'
import 'element-ui/lib/theme-chalk/index.css';
// import 'swiper/css/swiper.min.css'
import './style/index.css'
import './style/demo.css'
import './style/demo2.css'
import './style/demo3.css'

Vue.config.productionTip = false
Vue.use(ElementUI);
new Vue({
	el: '#app',
	router,
	render: h => h(App),
}).$mount('#app')